import React from 'react';
import { ConfirmDialog } from 'swag-client-common/components/info/confirm-dialog';
import { AdminMode } from 'swag-common/constants/admin.constants';
export const AdminModeExitPopup = ({
  open,
  adminMode,
  onConfirm,
  onCancel
}) => {
  const getTitle = () => {
    if (adminMode === AdminMode.CreatingCart) {
      return 'Building a cart';
    }
    if (adminMode === AdminMode.EditingCart) {
      return 'Editing a cart';
    }
  };
  const getMessage = () => {
    if (adminMode === AdminMode.CreatingCart) {
      return 'Are you sure you want to exit? All your progress will be lost if you proceed.';
    }
    if (adminMode === AdminMode.EditingCart) {
      return 'Are you sure you want to exit? The edits made to the cart will be saved and you will be redirected back to the dashboard.';
    }
  };
  return /*#__PURE__*/React.createElement(ConfirmDialog, {
    open: open,
    onConfirm: onConfirm,
    onCancel: onCancel,
    title: getTitle(),
    msg: getMessage()
  });
};